import type { IconDefinition } from '@ant-design/icons-svg/lib/types';

const PlusOutlined: IconDefinition = {
  icon: {
    tag: 'svg',
    attrs: {
      viewBox: '64 64 896 896',
      focusable: 'false',
    },
    children: [
      {
        tag: 'defs',
        attrs: {},
        children: [
          {
            tag: 'style',
            attrs: {},
          },
        ],
      },
      {
        tag: 'path',
        attrs: {
          d: 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z',
        },
      },
      {
        tag: 'path',
        attrs: {
          d: 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z',
        },
      },
    ],
  },
  name: 'plus',
  theme: 'outlined',
};

export default PlusOutlined;
